<template>
  <main-layout>
    <v-content>
      <v-container>
        <transaction-tabs />
        <router-view />
      </v-container>
    </v-content>
  </main-layout>
</template>
<script>
import TransactionTabs from "./tabs";
export default {
  components: {
    TransactionTabs,
  },
};
</script>
